package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.bundle.components.BundleImage
import one.healthium.onboarding.domain.configs.CoachIntroScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.common.utils.toContentScale
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppScaffold
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.blue_1

interface CoachIntroEventDelegate {
    fun onNextClicked()
}

@Composable
internal fun CoachIntroScreen(
    eventDelegate: CoachIntroEventDelegate,
    screenConfig: CoachIntroScreenConfig,
) {
    UserDataProvider { userState, _ ->
        AppScaffold {
            CoachIntroScreenContent(
                screenConfig = screenConfig,
                userState = userState,
                onNextClicked = eventDelegate::onNextClicked,
            )
        }
    }
}

@Composable
internal fun CoachIntroScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: CoachIntroScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(screenConfig.backgroundColor?.toColor() ?: blue_1)
            .padding(horizontal = 24.dp)
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState()),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Spacer(Modifier.weight(1f))
        Spacer(Modifier.height(24.dp))
        AppText(
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.header,
            color = AppTheme.colors.textInverted100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(12.dp))
        AppText(
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.textInverted100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(42.dp))
        BundleImage(
            modifier = Modifier.fillMaxWidth(),
            name = screenConfig.image,
            contentScale = screenConfig.imageMode?.toContentScale(),
        )
        Spacer(Modifier.weight(1f))
        Spacer(Modifier.height(16.dp))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp),
            text = screenConfig.ctaTitle,
            onClick = onNextClicked,
        )
        Spacer(Modifier.height(24.dp))
    }
}
